const state = {
  listPendingJobsEmployer: [],
  listCurrentOfferJobs: [],
  listOngoingJobsEmployer: [],
  listApprovedJobsEmployer: [],
  listCompletedJobsEmployer: [],
  listSearchJobsEmployer: [],
  totalJobsEmployer: 0,
  listOngoingJobsTalent: [],
  listPendingJobsTalent: [],
  listCompletedJobsTalent: [],
  totalJobsTalent: 0,
  submittedJobInfo: {},
  invoiceList: []
}

export default state
